import React from 'react'
import { ProgressMeter } from '@paypalcorp/pp-react'

type Props = {
  path: string
  applicationType: string
  creditApplicationLoading: boolean
}

type ProgressMeterValues = {
  max: string
  value: string
  steps: string
  title: string
}

const withProgressMeter = function (
  progressMeterValues: ProgressMeterValues,
  Component: React.ComponentType<Props>,
) {
  return function WrappedComponent(props: Props) {
    return (
      <>
        <ProgressMeter
          max={progressMeterValues.max}
          value={progressMeterValues.value}
          steps={progressMeterValues.steps}
          title={progressMeterValues.title}
          className="applicationProgressMeter"
          data-testid="progress-meter"
        />
        <Component {...props} />
      </>
    )
  }
}

export default withProgressMeter
